import { useStepLineStateUpdate } from '../StepLineContext'

export default function useAllowStepLineStateChange() {
  const update = useStepLineStateUpdate()
  return (allow: boolean) => update({ __allowChangeState: allow })
}
